import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DashboardShell } from "@/components/layout/DashboardShell";
import { carrierNav } from "@/pages/carrier/nav";
import { StatusPill } from "@/components/common";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Package } from "lucide-react";

export default function MyLoads() {
  const [loads, setLoads] = useState(null);
  useEffect(() => { api.get("/carrier/my-loads").then((r) => setLoads(r.data)); }, []);
  if (!loads) return <DashboardShell nav={carrierNav}><div className="py-24 grid place-items-center"><Loader2 className="animate-spin text-xd-orange" size={32} /></div></DashboardShell>;

  return (
    <DashboardShell nav={carrierNav} title="My Loads">
      {loads.length === 0 ? (
        <div className="py-16 text-center border border-dashed border-xd-border rounded-xl">
          <Package size={32} className="mx-auto text-xd-dim" />
          <p className="mt-3 text-xd-muted">No booked loads yet.</p>
          <Button asChild className="mt-4 bg-xd-orange hover:bg-xd-orangeH text-white"><Link to="/find-loads">Find Loads</Link></Button>
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-xd-border">
          <table className="w-full text-sm">
            <thead className="bg-xd-surface text-xd-dim text-xs uppercase tracking-wide">
              <tr>{["XD #", "Lane", "Pickup", "Pay", "Status", ""].map((h) => <th key={h} className="text-left font-bold px-4 py-3 whitespace-nowrap">{h}</th>)}</tr>
            </thead>
            <tbody>
              {loads.map((l) => (
                <tr key={l.id} data-testid={`myload-${l.xd_number}`} className="border-t border-xd-border hover:bg-xd-surface">
                  <td className="px-4 py-3 font-mono text-xs text-xd-dim">{l.xd_number}</td>
                  <td className="px-4 py-3 font-medium whitespace-nowrap">{l.origin_city} → {l.dest_city}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{l.pickup_date}</td>
                  <td className="px-4 py-3 font-bold">${l.total_pay?.toLocaleString()}</td>
                  <td className="px-4 py-3"><StatusPill status={l.status} /></td>
                  <td className="px-4 py-3"><Button asChild size="sm" variant="outline" className="border-xd-border text-white hover:bg-xd-surface"><Link to={`/find-loads/${l.id}`}>View</Link></Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </DashboardShell>
  );
}
